import type { FC } from "react";

import { FlavorFinder as MobileFirstFlavorFinder } from "../MobileFirstFlavorFinder";

import type { FlavorFinderDataType } from "./types/FlavorFinderTypes";

import { FlavorFinderContextProvider, FlavorFinderViewSwitch } from "./components";

import "./FlavorFinder.scss";

export type FlavorFinderProps = {
  data: FlavorFinderDataType;
};

export const FlavorFinder: FC<FlavorFinderProps> = ({ data }) => {
  const isMobileFriendlyFlavorFinderEnabled = data?.isMobileFirstFlavorFinderEnabled ?? false;

  if (isMobileFriendlyFlavorFinderEnabled) {
    return <MobileFirstFlavorFinder data={data} />;
  }

  return (
    <FlavorFinderContextProvider data={data}>
      <div className="flavorfinder__container">
        <FlavorFinderViewSwitch />
      </div>
    </FlavorFinderContextProvider>
  );
};
